import Axios from "axios";
import User from "./User";
import moment from "moment";
import Services from "./Services";
import Vue from "vue";

class EventGroupsClass {

  constructor() {
    this.eventGroups = /** @type {EventGroup[]} */ ([]);
    this.initialized = false;
  }

  get(id) {
    return this.eventGroups.find(e => e.id === id);
  }

  getEvent(id) {
    for (let eventGroup of this.eventGroups) {
      let event = eventGroup.events.find(e => e.id === id);
      if (event) {
        return event;
      }
    }
  }

  /**
   * @param {number} id
   */
  getForService(id) {
    let toReturn = [];
    for (let group of this.eventGroups) {
      if (group.service == id) {
        toReturn.push(group);
      }
    }
    if (toReturn.length == 0) {
      return null;
    }
    return toReturn;
  }

  /**
   * @param {number} id
   */
  getForServiceAccordingToFare(id, includePaidSchedules = true) {
    let toReturn = [];
    for (let group of this.eventGroups) {
      if (group.service == id && (group.price === 0 || includePaidSchedules)) {
        toReturn.push(group);
      }
    }
    if (toReturn.length == 0) {
      return null;
    }
    return toReturn;
  }

  async init() {
    if(!User.token) {
      return;
    }
    let groups = await Axios.get(CONFIG.urlServer + "/api/booking_event_groups", {
      params: {
        perPage: -1
      },
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    let newArray = [];
    for (let definition of groups.data.data) {
      let eventGroup = new EventGroup(definition);
      await eventGroup.load();
      newArray.push(eventGroup);
    }
    this.eventGroups = newArray;
    this.initialized = true;
  }

}

/**
 * @typedef EventGroupDefinition
 * @property {number} id
 * @property {{fr: string, en: string}} name
 * @property {{fr: string, en: string}} description
 * @property {number} service
 * @property {number} price
 * @property {boolean} deleted
 */

class EventGroup {

  /**
   * @param {EventGroupDefinition} definition
   */
  constructor(definition) {
    this.id = definition.id;
    this.name = definition.name;
    this.service = definition.service;
    this.price = definition.price || 0;
    this.deleted = definition.deleted;
    this.entityType = "EventGroup";
    this.events = /** @type {Event[]} */ ([]);
  }

  getService() {
    return Services.get(this.service);
  }

  /**
   *
   * @param {number} id
   * @return {Event}
   */
  get(id) {
    return this.events.find(s => s.id === id);
  }

  getEventsForDate(isoDate) {
    let date = moment(isoDate);
    return this.events.filter(e => e.start.format("YYYY-MM-DD") === date.format("YYYY-MM-DD"));
  }

  async load() {
    let events = await Axios.get(CONFIG.urlServer + "/api/booking_events?augment=stats&after=now&perPage=-1&group=" + this.id, {
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    this.events = [];
    for (let event of events.data.data) {
      this.events.push(new Event(event, this.service, this));
    }
  }
}

class Event {
  /**
   * @typedef EventDefinition
   * @property {number} id
   * @property {number} group
   * @property {number} maxAvailable
   * @property {string} start
   * @property {Service} service
   * @property {number} price
   * @property {string} end
   * @property {string} name
   * @property {string} description
   */

  /**
   * @param {EventDefinition} definition
   */
  constructor(definition, service, group) {
    this.id = definition.id;
    this.group = group;
    this.name = definition.name;
    this.service = service;
    this.description = definition.description;
    this.maxAvailable = definition.maxAvailable;
    this.price = definition.price;
    this.start = moment(definition.start);
    this.end = moment(definition.end);
    this.stats = definition.stats;
    if (this.stats && this.stats.reservation >= 0 && this.maxAvailable > 0) {
      this.remainingAvailable = Math.max(this.maxAvailable - this.stats.reservation, 0);
    }
  }

  getService() {
    return Services.get(this.service);
  }

  /**
   * @param {moment.Moment} start
   * @param {moment.Moment} end
   * @param {number} amount
   * @param {string} token?
   */
  async createReservation(amount, token) {
    let result = await Axios.post(CONFIG.urlServer + "/api/reservations", {
      event: this.id,
      payments: [{
        from: token,
        processor: token ? "stripe" : "none",
        amount: amount || 0,
        currency: "CAD"
      }],
      start: this.start.format("YYYY-MM-DD HH:mm:ss"),
      end: this.end.format("YYYY-MM-DD HH:mm:ss"),
      total: amount || 0,
      currency: "CAD",
    }, {
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    return result;
  }
}

let EventGroups = new EventGroupsClass();
export default EventGroups;
